import { render, staticRenderFns } from "./phoneCall.vue?vue&type=template&id=b941c9fe&scoped=true"
import script from "./phoneCall.vue?vue&type=script&lang=js"
export * from "./phoneCall.vue?vue&type=script&lang=js"
import style0 from "./phoneCall.vue?vue&type=style&index=0&id=b941c9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b941c9fe",
  null
  
)

export default component.exports